import { SwitchLineInput, Banner, Box, Flex } from '@sequencehq/core-components'
import { FC } from 'react'
import {
  BorderRadius6,
  GreyGrey10,
  GreyGrey70,
  GreyGrey80,
  IndigoIndigo60,
  Link,
  Primary13Regular,
  Primary13SemiBold,
  Text
} from '@sequencehq/core-components'
import {
  GoCardlessInspectorItemData,
  useGoCardlessPaymentWidget
} from './useGoCardlessPaymentWidget'

interface GoCardlessPaymentInspectorItemProps {
  fieldData: {
    acceptPaymentsViaGoCardless: {
      value: boolean
      disabled?: boolean
    }
  }
  onChange: (newData: GoCardlessInspectorItemData) => void
  disabled?: boolean
  disabledReason: string | null
}

export const GoCardlessPaymentWidget: FC<
  GoCardlessPaymentInspectorItemProps
> = props => {
  const { fields } = useGoCardlessPaymentWidget({
    dataFromInterface: {
      acceptPaymentsViaGoCardless: props.fieldData.acceptPaymentsViaGoCardless
    },
    onChange: props.onChange,
    disabled: props.disabled
  })

  return (
    <Flex flexDirection="column" gap="8px">
      <Text {...Primary13SemiBold} color={GreyGrey80}>
        GoCardless payments
      </Text>
      {props.disabledReason && (
        <Banner
          variant="warning"
          data-testid="gocardless.inspector.content.disabledReasonBanner"
        >
          {props.disabledReason}
        </Banner>
      )}
      <Box
        borderRadius={BorderRadius6}
        backgroundColor={GreyGrey10}
        padding="8px"
      >
        <SwitchLineInput
          isDisabled={fields.acceptPaymentsViaGoCardless.isDisabled}
          text="Accept payments via GoCardless"
          value={fields.acceptPaymentsViaGoCardless.value}
          onChange={fields.acceptPaymentsViaGoCardless.onChange}
          styles={{
            label: {
              ...Primary13Regular,
              color: GreyGrey80
            }
          }}
          data-testid="gocardless.inspector.content.acceptPayments"
        />
      </Box>
      <Text {...Primary13Regular} color={GreyGrey70}>
        When this is enabled, a GoCardless payment link will be added to
        invoices. Once a payment method is on file for a customer, Sequence will
        auto-charge the customer when you send subsequent invoices.{' '}
        <Link
          to="https://docs.sequencehq.com/connectors/gocardless"
          target="_blank"
          rel="noreferrer"
          color={IndigoIndigo60}
        >
          Learn more.
        </Link>
      </Text>
    </Flex>
  )
}
